module.exports = __webpack_public_path__ + "media/images/home-bg-a6d9cf8ec667f478720f035bdb39e26e.jpg";